import { GenericRepository } from '@/repository/GenericRepository';
import { searchExclusionRules } from '@/graphql/queries';
import * as mutations from '@/graphql/mutations';
import {
  CreateExclusionRuleInput,
  CreateExclusionRuleMutation,
  CreateExclusionRuleMutationVariables,
  DeleteExclusionRuleMutationVariables,
  ExclusionRule,
  UpdateExclusionRuleInput,
  UpdateExclusionRuleMutation,
  UpdateExclusionRuleMutationVariables,
} from '@/API';
import { GraphQLOptionsV6, GraphQLResult } from '@aws-amplify/api-graphql';

/**
 * Repository for managing ExclusionRule model
 */
export class ExclusionRuleRepository extends GenericRepository<ExclusionRule> {
  constructor() {
    super();
  }

  async search(queryVariables: GraphQLOptionsV6['variables']) {
    return (
      await this.client.graphql({
        query: searchExclusionRules,
        variables: queryVariables,
      })
    ).data.searchExclusionRules;
  }

  public async save(input: CreateExclusionRuleInput): Promise<ExclusionRule> {
    const response = (await this.client.graphql({
      query: mutations.createExclusionRule,
      variables: { input } as CreateExclusionRuleMutationVariables,
    })) as GraphQLResult<CreateExclusionRuleMutation>;
    return response.data!.createExclusionRule!;
  }

  public async update(input: UpdateExclusionRuleInput): Promise<ExclusionRule> {
    const response = (await this.client.graphql({
      query: mutations.updateExclusionRule,
      variables: { input } as UpdateExclusionRuleMutationVariables,
    })) as GraphQLResult<UpdateExclusionRuleMutation>;
    return response.data!.updateExclusionRule!;
  }

  public async delete(id: string): Promise<void> {
    await this.client.graphql({
      query: mutations.deleteExclusionRule,
      variables: { input: { id } } as DeleteExclusionRuleMutationVariables,
    });
  }
}
